<template>
  <figure 
    class="image"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <!-- Основное изображение (превью для больших GIF) -->
    <img
      class="image__base"
      :alt="props.data.caption"
      :src="previewUrl"
      :height="`${LIST_ITEM_HEIGHT}px`"
      loading="lazy"
    />
    <!-- Наложение GIF (только для больших файлов при наведении) -->
    <transition name="image__animation">
      <img
        v-if="showGif"
        class="image__overlay"
        :alt="props.data.caption"
        :src="props.data.url"
        :height="`${LIST_ITEM_HEIGHT}px`"
      />
    </transition>
    <figcaption>{{ props.data.caption }}</figcaption>
  </figure>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { Props } from './props';
  import { LIST_ITEM_HEIGHT, MAX_GIF_SIZE } from '../../config/config';
  //---------------------------------------------
  const props = defineProps(Props());
  //---------------------------------------------
  const isHovered = ref(false);
  //---------------------------------------------
  //Проверка, является ли изображение большим GIF
  const isBigGif = computed(() => {
    return props.data.size / 1024 / 1024 > MAX_GIF_SIZE / 1024 / 1024;
  });
  //URL для превью (для больших GIF) или основное изображение
  const previewUrl = computed(() => {
    return isBigGif.value ? props.data.preview : props.data.url;
  });
  //Показывать ли GIF поверх превью
  const showGif = computed(() => {
    return isBigGif.value && isHovered.value;
  });
  //---------------------------------------------
  //Действия при наведении мышки на изображение
  const handleMouseEnter = () => {
    if(!isBigGif.value) return;
    isHovered.value = true;
  };
  //Действия, когда курсор покидает изображение
  const handleMouseLeave = () => {
    isHovered.value = false;
  };
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>